import React, { useContext, useState, useEffect } from 'react';
import { FormProvider, useForm, UseFormMethods } from 'react-hook-form';
import { DialogActionBar } from 'src/components/common/Dialog.redesign';
import AddressData from 'src/components/controls/forms/composite/AddressData';
import PersonData from 'src/components/controls/forms/composite/PersonData';
import { FormContainer, FormError, FormRow, FormSection, TextInput } from 'src/components/controls/forms/reactHookForm';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { SelectItem } from 'src/models/common/SelectItem';
import IOwner from 'src/models/IOwner';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import useFetch from 'use-http';
import { CreateOwnerAction } from './CreateOwner';
import { AnyObject } from 'react-final-form';
import PhoneNumberType from 'src/models/PhoneNumberType';
import PhoneNumber from 'src/models/PhoneNumber';
import PhoneNumberData from 'src/components/controls/forms/composite/PhoneNumberData';
import USPSCityState from 'src/models/USPSCityState';

interface ICreateBusinessProps {
    className?: string;
    style?: React.CSSProperties;
    states?: Array<SelectItem>;
    onOwnerCreated: (owner: IOwner) => void;
    actions: CreateOwnerAction[];
    phoneNumberTypes?: PhoneNumberType[];
}

const CreateBusiness = (props: ICreateBusinessProps) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const [uspsData, setUspsData] = useState<USPSCityState>(undefined);
    const [stateValue, setStateValue] = useState<string | number>(undefined);
    const { post, response, error, get } = useFetch();

    const methods = useForm();

    // Effect to update the State and City after zipcode has been entered
    useEffect(() => {
        if (!!uspsData) {
            console.log('this is the data from the usps call, ', uspsData);
            let uspsState: string = uspsData?.zipCode?.state;
            let uspsCity: string = uspsData?.zipCode?.city;
            console.log('what is the value of this?, ', uspsState);
            console.log('what is the value of this?, ', uspsCity);
            updateCityState(uspsState, uspsCity);
        }
    }, [uspsData]);

    const updateCityState = (state: string, city: string) => {
        console.log('are these the states, ', props?.states);
        let stateId = !!props?.states ? props?.states.find((s) => s.name === state)?.id : undefined;
        console.log('state id, ', stateId);

        if (!!stateId && !!city) {
            methods.setValue('address.state.id', stateId);
            methods.setValue('address.city', city);
            setStateValue(stateId);
        }
    };

    const getCityState = async (zipCode: string) => {
        const result = await get(`v1.0/usps/${zipCode}/local-source`);

        if (response.ok) {
            setUspsData(result);
        }
    };

    const onSubmit = async (data: AnyObject) => {
        let phoneNumberChanges: string = 'phoneNumberChanges';
        let phoneNumberAdds: string = 'phoneNumberAdds';
        let phoneNumberUpdates: string = 'phoneNumberUpdates';

        if (!!data[phoneNumberChanges]) {
            let updates: PhoneNumber[] = data[phoneNumberChanges][phoneNumberAdds];
            data[phoneNumberChanges][phoneNumberUpdates] = updates;
        }

        const result = await post(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/business`,
            data as OwnerBusiness
        );

        if (response.ok) {
            data.id = parseInt(result, 10);
            data.ownerType = 'Business';
            props.onOwnerCreated(data as OwnerBusiness);
        }
    };

    const actions = (formMethods: UseFormMethods) => {
        const { isDirty, isSubmitting, isSubmitted, isValid } = methods.formState;

        if (props.actions && props.actions.length > 0) {
            return props.actions.map((a: CreateOwnerAction) => {
                if (a.isSave) {
                    return (
                        <Button
                            key={a.id}
                            disabled={isSubmitting || (isSubmitted && !isValid) || !isDirty}
                            intent={a.intent}
                            text={a.text}
                            onClick={() => formMethods.handleSubmit(onSubmit)()}
                        />
                    );
                } else {
                    return <Button key={a.id} intent={a.intent} text={a.text} onClick={a.action} />;
                }
            });
        }
        return <></>;
    };

    return (
        <>
            <FormError error={error} message="Unexpected error while saving owner." />
            <div className={props.className} style={props.style}>
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(onSubmit)}>
                        <FormContainer>
                            <FormSection title="Business Details">
                                <FormRow layout={[5, 5]}>
                                    <TextInput isRequired={true} label="Business Name" name={'name'} />
                                    <TextInput label="Tax Id" name={'ssnTaxId'} />
                                </FormRow>
                            </FormSection>
                            <FormSection title="Contact Person">
                                <TextInput label="Title" name={'contactPersonTitle'} />

                                <PersonData namePrefix="contactPerson" required={true} />
                            </FormSection>
                            <FormSection title="Address">
                                <AddressData namePrefix="address." states={props.states} getCityState={getCityState} stateValue={stateValue} />
                            </FormSection>
                            <FormSection title="Phone Number">
                                <PhoneNumberData phoneTypes={props?.phoneNumberTypes} />
                            </FormSection>
                        </FormContainer>
                    </form>
                </FormProvider>
            </div>
            <DialogActionBar>{actions(methods)}</DialogActionBar>
        </>
    );
};

export default CreateBusiness;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/createOwner/CreateBusiness.tsx